import type {ComponentPropsWithoutRef, CSSProperties} from 'react';
import styles from './loading-icon.module.css';

type Props = {
  readonly size?: 'sm' | 'md' | 'lg';
  readonly bgColor?: string;
} & ComponentPropsWithoutRef<'div'>;

function LoadingIcon({size = 'sm', bgColor, ...props}: Props) {
  const customBgColor = bgColor ?? '#fff';

  return (
    <div
      className={styles.loader}
      data-size={size}
      style={{'--bg-color': customBgColor} as CSSProperties}
      {...props}
    />
  );
}

export default LoadingIcon;
